<a class="movable" (mousedown)="startMoving($event)"
(mousemove)="move($event)"
(mouseup)="stopMoving()" [ngStyle]="{'inset': newPosition[1] + 'px ' +newPosition[0] +'px'}">
    <div class="burger-container">
        <ng-container *ngIf="rhythmService.pausedGame">
            <img class="menu-icon pause-mode" src="assets/pause-menu-alt.svg" (click)="pauseGame()" />
        </ng-container>
        <ng-container *ngIf="!rhythmService.pausedGame">
            <img class="menu-icon" src="assets/pause-menu-alt.svg" (click)="pauseGame()" />
        </ng-container>
        <img class="menu-arrow" src="assets/pause-menu-arrow.svg" (click)="pauseGame()" />
        <img class="toogle-fullscreen" src="assets/fullscreen.svg"  (click)="toggleFullscreen()"/>
    </div>
</a>

